// environment.js
const isProduction = process.env.NODE_ENV === 'production';
const websiteName = 'lyora.io';

module.exports = { isProduction, websiteName };